import gql from 'graphql-tag';

const enrollPerson = gql`
mutation enrollPerson($enrollPersonInput: EnrollPersonInput) {
  enrollExistingPerson(input: $enrollPersonInput) {
    id
    personId
    firstName
    middleName
    lastName
    phoneNumber
    addressLine1
    addressLine2
    city
    state
    zipCode
    country
    emailAddress
    birthMonth
    birthDay
    birthYear
    spouseFirstName
    spouseMiddleName
    spouseLastName
    spouseBirthMonth
    spouseBirthDay
    spouseBirthYear
    spouseEmailAddress
    spouseId
    spanishMaterial
    accountIndicator
    accountType
    accountStatus
    expiryDate
    autoRenew
    membershipTerm
    cardSentDate
  }
}
`;

export default enrollPerson;



// WEBPACK FOOTER //
// ./src/app/mutations/enrollPerson.js